import { render, staticRenderFns } from "./image-view.vue?vue&type=template&id=264f4fe2&scoped=true"
import script from "./image-view.vue?vue&type=script&lang=js"
export * from "./image-view.vue?vue&type=script&lang=js"
import style0 from "./image-view.vue?vue&type=style&index=0&id=264f4fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f4fe2",
  null
  
)

export default component.exports